import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Nav from './nav/Nav';
import About from './about/About';
import Skills from './skills/Skills';
import Project from './projectz/Projects';
import Contact from './contact/Contact';
import './styles/app.css';
import Background from './background/Background';
import Blog from './blog/Blog';

const App = () => {
  return (
    <Router>
      <div className="app">
        <Background />
        <Nav />
        <main className="main">
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/projects" element={<Project />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
          </Routes>
        </main>
        <footer className="footer">
          © {new Date().getFullYear()} Krystle Mitchell ·{' '}
          <a href="https://github.com/krystleM26" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
        </footer>
      </div>
    </Router>
  );
};

export default App;
